import React from "react";
import { Container } from "react-bootstrap";
import "./Sixth.css";
import first from "../../../../Asset/Group-1.svg";
import second from "../../../../Asset/Group-2.svg";
import third from "../../../../Asset/Group-3.svg";
import fourth from "../../../../Asset/Group-4.svg";

const Sixth = () => {
  return (
    <>
      <section className="sixth-logistic-section">
        <Container>
          <div className="top-text-ourclient">
            <h2>
              WHY <span>PARTNER WITH US?</span>
            </h2>
          </div>
          <div className="para-content">
            <p>
              As an offshore IT service provider specializing in logistics and
              shipping, we offer innovative, cost-effective solutions tailored
              to your industry's unique challenges. Industry
              expertise,Cost-Effective innovation, Personalized Solutions, and
              Comprehensive Support are 4 major reasons you must choose us.
            </p>
          </div>
          <div className="partner_content_section">
            <div className="row partner_content_row">
              <div className="col-xl-6 col-lg-6 col-md-6 col-sm-6">
                <div className="partner_content_box">
                  <div className="row">
                    <div className="col-xl-8 col-lg-8 col-md-8">
                      <div className="left_side">
                        <h3>Industry Expertise</h3>
                        <p>
                          Our team combines deep technical knowledge with
                          extensive logistics experience, delivering IT
                          solutions tailored specifically to the shipping and
                          logistics sector.
                        </p>
                      </div>
                    </div>
                    <div className="col-xl-4 col-lg-4 col-md-4">
                      <div className="right_side h-100">
                        <div className="img_part">
                          <img src={first} alt="main" className="w-100" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-xl-6 col-lg-6 col-md-6 col-sm-6">
                <div className="partner_content_box">
                  <div className="row">
                    <div className="col-xl-8 col-lg-8 col-md-8">
                      <div className="left_side">
                        <h3>Cost-Effective Innovation</h3>
                        <p>
                          As an offshore provider, we offer innovative,
                          budget-friendly IT services that drive efficiency and
                          give you a competitive edge in the global market.
                        </p>
                      </div>
                    </div>
                    <div className="col-xl-4 col-lg-4 col-md-4">
                      <div className="right_side h-100">
                        <div className="img_part">
                          <img src={second} alt="main" className="w-100" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-xl-6 col-lg-6 col-md-6 col-sm-6">
                <div className="partner_content_box">
                  <div className="row">
                    <div className="col-xl-8 col-lg-8 col-md-8">
                      <div className="left_side">
                        <h3>Personalized Solutions</h3>
                        <p>
                          We recognize that every logistics operation is unique.
                          Our flexible approach allows us to customize our IT
                          solutions to match your specific processes,
                          challenges, and growth objectives.
                        </p>
                      </div>
                    </div>
                    <div className="col-xl-4 col-lg-4 col-md-4">
                      <div className="right_side h-100">
                        <div className="img_part">
                          <img src={third} alt="main" className="w-100" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-xl-6 col-lg-6 col-md-6 col-sm-6">
                <div className="partner_content_box">
                  <div className="row">
                    <div className="col-xl-8 col-lg-8 col-md-8">
                      <div className="left_side">
                        <h3>Comprehensive Support</h3>
                        <p>
                          From implementation to ongoing maintenance, we provide
                          round-the-clock support to ensure your logistics IT
                          systems run smoothly and adapt to your evolving needs.
                        </p>
                      </div>
                    </div>
                    <div className="col-xl-4 col-lg-4 col-md-4">
                      <div className="right_side h-100">
                        <div className="img_part">
                          <img src={fourth} alt="main" className="w-100" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Container>
      </section>
    </>
  );
};

export default Sixth;
